import { render, staticRenderFns } from "./shopAddress.vue?vue&type=template&id=c662ac6c&scoped=true"
import script from "./shopAddress.vue?vue&type=script&lang=ts"
export * from "./shopAddress.vue?vue&type=script&lang=ts"
import style0 from "./shopAddress.vue?vue&type=style&index=0&id=c662ac6c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c662ac6c",
  null
  
)

export default component.exports